import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BackButton from "../../../components/Form/BackButton";
import { API, defaultLimitPagination, get } from "../../../config";
import Pagination from "../../common/Pagination";
import Spin from "../../common/Spin";
import { debounce } from "lodash";
import RolesActionButton from "./components/RolesActionButton";
import AddRoles from "./AddRoles";
import SearchBox from "../../common/SearchBox";

const Roles = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [rolesList, setRolesList] = useState();
  const [rolesLoading, setRolesLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");

  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [showRoles, setShowRoles] = useState(false);

  // *API Call for Geting Roles - Start
  const fetchRoles = useCallback(
    async (passLimit, passPage) => {
      try {
        setRolesLoading(true);
        const { data } = await get(
          `${API.GET_ROLE_LIST}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }`
        );
        setRolesLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const roleList = data?.data?.data;
        setRolesList(roleList);
      } catch (error) {
        setRolesLoading(false);
        setRolesList();

        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, sortOrder, sortField]
  );

  const rolesModal = () => {
    fetchRoles(limit, page);
  };

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);
  // *API Call for Geting Roles - End

  // *Roles Table Row and Column Generation, Filtering and Sorting of Record - Start
  const rolesGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: rolesList[i]?.id,
        id: rolesList[i]?.id ? rolesList[i]?.id : "",
        name: rolesList[i]?.name ? rolesList[i]?.name : "",
        type: rolesList[i]?.type ? rolesList[i]?.type : "",
        status: (
          <RolesActionButton
            id={rolesList[i]?.id}
            rolesModal={rolesModal}
            statusMode={true}
            status={rolesList[i]?.status}
            fetchRoles={rolesModal}
          />
        ),
        action: (
          <RolesActionButton id={rolesList[i]?.id} rolesModal={rolesModal} />
        ),
      });
    }
    return items;
  };
  const rolesData = rolesGenerator(rolesList?.length);

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
    },
    {
      dataField: "action",
      text: "Action",
      className: "text-center",
      style: { width: "127px" },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  // const onSearchChange = (e) => {
  //   const value = e.target.value;
  //   setSearchParam(value);
  //   setPage(1);
  // };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchRoles(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchRoles(limit, page);
  };
  // *Roles Table Row and Column Generation, Filtering and Sorting of Record - End

  useEffect(() => {
    navigate(
      `/admin/roles?limit=${limit ? limit : defaultLimitPagination}&page=${
        page ? page : 1
      }&search=${searchParam ? searchParam : ""}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      }
    );
  }, [navigate, limit, searchParam, page, sortField, sortOrder]);

  const toggleRolesModal = () => {
    showRoles && rolesModal();
    setShowRoles(!showRoles);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  return (
    <>
      {" "}
      <div className="cms-page">
        <div className="page-content-block">
          <div className="full-content-block">
            <h1 className="page-title">
              <BackButton />
              Roles
            </h1>
            <div className="content-details">
              <div className="table-top-btn">
                <SearchBox
                  placeholder={"Search Roles"}
                  searchParamData={searchParamData}
                  handleSearchChange={handleSearchChange}
                  handleClearSearch={handleClearSearch}
                />
                <div className="table-btn">
                  <Button variant="primary" onClick={toggleRolesModal}>
                    Add New
                  </Button>
                </div>
              </div>
              <div className="custom-table">
                {rolesLoading && <Spin />}
                <BootstrapTable
                  keyField="roles_id"
                  remote
                  data={rolesData}
                  columns={columns}
                  onTableChange={handleTableChange}
                  noDataIndication="No Data Found"
                />
                <Pagination
                  total={total}
                  limit={parseInt(limit)}
                  currentPage={page}
                  updateLimit={handleUpdateLimit}
                  updatePage={handleChangePage}
                  from={from}
                  to={to}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showRoles && (
        <AddRoles
          toggleRolesModal={toggleRolesModal}
          rolesModal={rolesModal}
          showRoles={showRoles}
        />
      )}
    </>
  );
};

export default Roles;
